/**
 * Recursos dos Relatórios que o ponteiro de uma novidade sabe apontar. Ver `spotlightTargets.js`.
 *
 * A tela é uma casca de abas em estado do React (sem `?tab=`): todas as abas existem assim que a
 * tela abre, então o destino é a própria tela. Cada aba tem o recurso de plano dela; sem ele a aba
 * aparece com um cadeado e o conteúdo vira o convite de upgrade, então o ponteiro só vai a quem
 * tem a aba liberada (ou está no teste grátis). A aba de qualidade de vídeo é só do super admin.
 */

const BARRA = "Barra da tela";
const ABAS = "Abas de relatório";

const aba = (id, label, feature, hint) => ({
  key: `reports.tab-${id}`,
  navKey: "reports",
  group: ABAS,
  label: `Aba ${label}`,
  path: "/reports",
  requires: "page",
  feature,
  minLevel: 30,
  hint,
});

export const REPORTS_TARGETS = [
  {
    key: "reports.export",
    navKey: "reports",
    group: BARRA,
    label: "Botão Exportar",
    path: "/reports",
    requires: "page",
    minLevel: 30,
    hint: "Exporta os dados da aba aberta, com o período e os filtros escolhidos.",
  },
  {
    key: "reports.period-and-refresh",
    navKey: "reports",
    group: BARRA,
    label: "Período, horário comercial e atualizar",
    path: "/reports",
    requires: "page",
    minLevel: 30,
    hint: "Escolhe o período, liga ou desliga o recorte de horário comercial e recarrega os números.",
  },
  {
    key: "reports.tabs",
    navKey: "reports",
    group: BARRA,
    label: "Barra de abas",
    path: "/reports",
    requires: "page",
    minLevel: 30,
    hint: "As abas de relatório da conta; as que o plano não inclui aparecem com um cadeado.",
  },
  {
    key: "reports.filters",
    navKey: "reports",
    group: BARRA,
    label: "Filtros (atendente, departamento, canal, tag)",
    path: "/reports",
    requires: "page",
    minLevel: 30,
    hint: "Recortam todos os números da aba. Somem nas abas que o plano não inclui.",
  },
  aba("overview", "Visão Geral", "reports.overview", "Os indicadores principais do atendimento. É a aba em que a tela abre."),
  aba("attendance", "Atendimento", "reports.basic", "Volume, tempos e situação das conversas."),
  aba("agents", "Atendentes", "reports.agents", "O desempenho de cada atendente da equipe."),
  aba("channels", "Canais", "reports.channels", "Os números por canal de atendimento."),
  aba("ai-bots", "IA / Bots", "reports.basic", "O que os agentes de IA e os fluxos resolvem e o que transferem."),
  aba("sales", "Vendas & ROI", "reports.advanced", "Funil, receita e retorno do investimento."),
  aba("journey", "Jornada", "reports.advanced", "O caminho do contato entre os canais e as etapas."),
  aba("sla", "SLA & Times", "reports.sla", "Cumprimento de prazos de primeira resposta e resolução, por time."),
  aba("nps", "Satisfação", "reports.satisfaction", "As notas de NPS e CSAT dos clientes."),
  aba("video-calls", "Chamadas de vídeo", "reports.basic", "As chamadas de vídeo feitas pelo atendimento: duração, resultado e a pesquisa de qualidade."),
  aba("ads", "Ads Intelligence", "ads.enabled", "O desempenho das campanhas de anúncio que levam ao WhatsApp."),
  aba("ai-insights", "IA Insights", "reports.insights", "Análises geradas por IA sobre o atendimento."),
  aba("custom", "Personalizado", "reports.custom", "Painéis montados pela própria conta, com widgets, e link para compartilhar."),
];
